import Loadable from 'react-loadable';
import Loading from '../components/Loading'

const LoginView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "LoginView" */ '../views/LoginView/index'),
    loading: Loading
});
const OverView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "OverView" */ '../views/OverView/index'),
    loading: Loading
});
const TradeListView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "TradeListView" */ '../views/TradeView/list'),
    loading: Loading
});
const CanteenListView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "CanteenListView" */ '../views/CanteenView/list'),
    loading: Loading
});
const CanteenView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "CanteenView" */ '../views/CanteenView/index'),
    loading: Loading
});
const CanbuView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "CanteenView" */ '../views/CanbuView/list'),
    loading: Loading
});
const WeakView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "CanteenView" */ '../views/WeakView/list'),
    loading: Loading
});
const WeakDeviceView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "CanteenView" */ '../views/WeakView/device'),
    loading: Loading
});
const WeakBlacklistView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "CanteenView" */ '../views/WeakView/blacklist'),
    loading: Loading
});
const CanbuIndexView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "CanteenView" */ '../views/CanbuView/index'),
    loading: Loading
});
const CanteenWindowView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "CanteenWindowView" */ '../views/CanteenView/window'),
    loading: Loading
});
const CampusListView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "CanteenView" */ '../views/CampusView/list'),
    loading: Loading
});
const CampusIndexView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "CanteenView" */ '../views/CampusView/index'),
    loading: Loading
});
const StatementView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "StatementView" */ '../views/StatementView/index'),
    loading: Loading
});
const FundsView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "FundsView" */ '../views/FundsView/index'),
    loading: Loading
});
const FundsDownView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "FundsView" */ '../views/FundsDownView/index'),
    loading: Loading
});
const FundsCustomView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "FundsView" */ '../views/FundsView/custom'),
    loading: Loading
});
const FundsCustomListView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "FundsView" */ '../views/FundsView/customlist'),
    loading: Loading
});
const FundsCustomIndexView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "FundsView" */ '../views/FundsView/customindex'),
    loading: Loading
});
const MerchantListView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "MerchantListView" */ '../views/MerchantView/list'),
    loading: Loading
});
const MerchantView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "MerchantView" */ '../views/MerchantView/index'),
    loading: Loading
});
const AppListView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "AppListView" */ '../views/AppView/list'),
    loading: Loading
});
const AppView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "AppView" */ '../views/AppView/index'),
    loading: Loading
});
const SchoolListView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "SchoolListView" */ '../views/SchoolView/list'),
    loading: Loading
});
const SchoolView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "SchoolView" */ '../views/SchoolView/index'),
    loading: Loading
});
const ReadMeView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "ReadMeView" */ '../views/ReadMeView/index'),
    loading: Loading
});
const WalletView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "WalletView" */ '../views/WalletView/index'),
    loading: Loading
});
const WalletRechargeView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "WalletRechargeView" */ '../views/WalletView/recharge'),
    loading: Loading
});
const WalletBalanceView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "WalletBalanceView" */ '../views/WalletView/balance'),
    loading: Loading
});
const WalletStreamView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "WalletStreamView" */ '../views/WalletView/stream'),
    loading: Loading
});
const WalletOverdueView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "WalletOverdueView" */ '../views/WalletView/overdue'),
    loading: Loading
});
const WalletManageView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "WalletManageView" */ '../views/WalletView/manage'),
    loading: Loading
});
const WalletSettleView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "WalletSettleView" */ '../views/WalletView/settle'),
    loading: Loading
});
const WalletAccountsView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "WalletAccountsView" */ '../views/WalletView/accounts'),
    loading: Loading
});
const WalletRecordView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "WalletRecordView" */ '../views/WalletView/managerecord'),
    loading: Loading
});
const AccountView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "AccountView" */ '../views/AccountView/index'),
    loading: Loading
});
const AccountEditView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "AccountView" */ '../views/AccountView/edit'),
    loading: Loading
});
const WxProfitsharingListView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "WxProfitsharingListView" */ '../views/WxProfitsharingView/list'),
    loading: Loading
});
const WxProfitsharingView = Loadable({
    loader: () =>
        import( /* webpackChunkName: "WxProfitsharingView" */ '../views/WxProfitsharingView/index'),
    loading: Loading
});

export default [
    { path: "/login", name: "LoginView", component: LoginView },
    { path: "/overview", name: "OverView", component: OverView },
    { path: "/trade", name: "TradeListView", component: TradeListView },
    { path: "/canteen", name: "CanteenListView", component: CanteenListView },
    { path: "/canteen/:type(add|edit)/:id?", name: "CanteenView", component: CanteenView },
    { path: "/canteen/window/:type(add|edit)/:id?", name: "CanteenWindowView", component: CanteenWindowView },
    { path: "/campus", name: "CampusListView", component: CampusListView },
    { path: "/campus/:type(add|edit|detail)/:id?", name: "CampusIndexView", component: CampusIndexView },
    { path: "/canbu/list", name: "CanbuView", component: CanbuView },
    { path: "/canbu/:type(add|edit)/:id?", name: "CanbuIndexView", component: CanbuIndexView },
    { path: "/weak/list", name: "WeakView", component: WeakView },
    { path: "/weak/device", name: "WeakDeviceView", component: WeakDeviceView },
    { path: "/weak/blacklist", name: "WeakBlacklistView", component: WeakBlacklistView },
    { path: "/statement", name: "StatementView", component: StatementView },
    { path: "/funds", name: "FundsView", component: FundsView },
    { path: "/fundsdown", name: "FundsDownView", component: FundsDownView },
    { path: "/fundscustom/:type(add|edit)/:id?", name: "FundsCustomIndexView", component: FundsCustomIndexView },
    { path: "/fundscustom/:id", name: "FundsCustomView", component: FundsCustomView },
    { path: "/fundscustom", name: "FundsCustomListView", component: FundsCustomListView },
    { path: "/merchant", name: "MerchantListView", component: MerchantListView },
    { path: "/merchant/:type(add|edit)/:id?", name: "MerchantView", component: MerchantView },
    { path: "/app", name: "AppListView", component: AppListView },
    { path: "/app/:type(add|edit)/:id?", name: "AppView", component: AppView },
    { path: "/school", name: "SchoolListView", component: SchoolListView },
    { path: "/school/:type(add|edit|view)/:id?", name: "SchoolView", component: SchoolView },
    { path: "/readme/:index?", name: "ReadMeView", component: ReadMeView },
    { path: "/wallet", name: "WalletView", component: WalletView },
    { path: "/wallet/recharge", name: "WalletRechargeView", component: WalletRechargeView },
    { path: "/wallet/balance", name: "WalletBalanceView", component: WalletBalanceView },
    { path: "/wallet/stream", name: "WalletStreamView", component: WalletStreamView },
    { path: "/wallet/overdue", name: "WalletOverdueView", component: WalletOverdueView },
    { path: "/wallet/manage", name: "WalletManageView", component: WalletManageView },
    { path: "/wallet/manage/:id?", name: "WalletRecordView", component: WalletRecordView },
    { path: "/wallet/settle", name: "WalletSettleView", component: WalletSettleView },
    { path: "/wallet/accounts", name: "WalletAccountsView", component: WalletAccountsView },
    { path: "/account", name: "AccountView", component: AccountView },
    { path: "/account/edit", name: "AccountEditView", component: AccountEditView },
    { path: "/wxprofitsharing", name: "WxProfitsharingListView", component: WxProfitsharingListView },
    { path: "/wxprofitsharing/:type(add|edit)/:id?", name: "WxProfitsharingView", component: WxProfitsharingView },
]



// WEBPACK FOOTER //
// ./src/router/index.js